import { render, staticRenderFns } from "./approve-document.vue?vue&type=template&id=69989b59&scoped=true"
import script from "./approve-document.vue?vue&type=script&lang=ts"
export * from "./approve-document.vue?vue&type=script&lang=ts"
import style0 from "./approve-document.vue?vue&type=style&index=0&id=69989b59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69989b59",
  null
  
)

export default component.exports